// Phase A flip: /session redirects to the new math session at
// /play/session. Legacy SessionScreen.jsx goes dormant (deleted in
// Phase B).
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/session")({
  beforeLoad: () => {
    throw redirect({ to: "/play/session" });
  },
  component: () => null,
});
